import React, { FunctionComponent, useEffect, useState } from 'react';
import { Steps, Step } from '@gaiads/telia-react-component-library';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface CheckoutStepperProps {}

const CheckoutStepper: FunctionComponent<CheckoutStepperProps> = () => {
  const [stepIndex, setStepIndex] = useState(0);
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation('shop');

  useEffect(() => {
    switch (location.pathname) {
      case '/shop/checkout':
        setStepIndex(0);
        break;
      case '/shop/checkout/delivery':
        setStepIndex(1);
        break;
      case '/shop/checkout/summary':
        setStepIndex(2);
        break;
      default:
        setStepIndex(0);
    }
  }, [location.pathname]);

  const handleSelect = (_e: React.MouseEvent<HTMLDivElement, MouseEvent>, index: number) => {
    switch (index) {
      case 0:
        history.push('/shop/checkout');
        break;
      case 1:
        history.push('/shop/checkout/delivery');
        break;
    }
  };

  const handleSelectable = (index: number, selectedStepIndex: number) =>
    !(
      (selectedStepIndex === 0 && (index === 1 || index === 2)) ||
      (selectedStepIndex === 1 && index === 2) ||
      (selectedStepIndex === 2 && (index === 0 || index === 1))
    );

  return (
    <Steps selectedStepIndex={stepIndex} onSelect={handleSelect} isStepSelectable={handleSelectable}>
      <Step label="1" description={t('checkout.mainPage.stepperStepOne')} />
      <Step label="2" description={t('checkout.mainPage.stepperStepTwo')} />
      <Step label="3" description={t('checkout.mainPage.stepperStepThree')} />
    </Steps>
  );
};

export default CheckoutStepper;
